import React, { useEffect } from "react"
import s from "./PartnersArea.module.css"
import { useNavigate } from "react-router"
import ImageBanner from "../components/ImageBanner"
import content from "../data/pageContent.json"
import Header from "../components/Header"
import DownloadTable from "../components/DownloadTable"
import Footer from "../components/Footer"

const PartnersArea = () => {
  const userAuthenticated = true
  const navigate = useNavigate()
  const page = content["partners-area"]

  useEffect(() => {
    if (!userAuthenticated) {
      console.log("User not authenticated, redirecting to login page...")
      navigate("/partners-area/login")
    }
  })

  return (
    <>
      <main>
        <ImageBanner
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
          image={page.image}
        />
        <Header
          image={page.image}
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
        ></Header>
        <div className={"body"}>
          <div className={"body-container"}>
            <DownloadTable />
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default PartnersArea
